import { styles } from './template.scss';
import { styles as commonStyles } from '../../../../assets/common.scss';
import { styles as styleHelpers } from '../../../../assets/style-helpers.scss';
import { styles as widgetSharedStyles } from '../../../../assets/widget-shared.scss';
import { LinkColor, LinkType } from '../../../../ui/gzLinkComponent/types';
import { FontSizes, FontWeights } from '../../../../types/common/types';

export const templateProductTrialsApp = document.createElement('template');

templateProductTrialsApp.innerHTML = `
  <style>${widgetSharedStyles}</style>
  <style>${commonStyles}</style>
  <style>${styleHelpers}</style>
  <style>${styles}</style>

  <div class='wrapper'>

    <div class="header">
      <gz-in-product-trials-header id="gz-in-product-trials-header"></gz-in-product-trials-header>
    </div>

    <div class='loading-container'>
      <gz-progress-spinner spinnerwidth="large"></gz-progress-spinner>
    </div>

    <div class='product-trials-app-error-container'>
      <gz-image-repo id='product-trials-app-error-image'>
        <gz-title id='product-trials-app-error-title' fontSize='${FontSizes.HEADING_4}' fontWeight="${FontWeights.MEDIUM}"></gz-title>
        <gz-title id='product-trials-app-error-text' class="mb-3"></gz-title>
        <gz-link id='product-trials-app-error-link' type="${LinkType.UNDERLINE}" color="${LinkColor.PRIMARY}"></gz-link>
      </gz-image-repo>
    </div>

    <div id='product-trials-app-container'>
      <gz-trial-home-page id='product-trials-app-home-page'></gz-trial-home-page>
      <gz-landing-page id='product-trials-app-landing-page'></gz-landing-page>
    </div>
  </div>
`;
